import React from 'react'
import { Hidden } from '@paintscout/ui'
import type { PresentationNavFullProps } from '../PresentationNavFull'
import PresentationNavFull from '../PresentationNavFull'
import type { PresentationNavMobileProps } from '../PresentationNavMobile'
import PresentationNavMobile from '../PresentationNavMobile'

export interface PresentationNavProps extends PresentationNavMobileProps, PresentationNavFullProps {
  breakpoint: 'md' | 'lg'
}

export default function PresentationNav({ breakpoint, ...props }: PresentationNavProps) {
  if (breakpoint === 'lg') {
    return (
      <>
        <Hidden lgDown>
          <PresentationNavFull {...props} />
        </Hidden>
        <Hidden xlUp>
          <PresentationNavMobile {...props} />
        </Hidden>
      </>
    )
  } else if (breakpoint === 'md') {
    return (
      <>
        <Hidden mdDown>
          <PresentationNavFull {...props} />
        </Hidden>
        <Hidden lgUp>
          <PresentationNavMobile {...props} />
        </Hidden>
      </>
    )
  }
}
